.root {
  display: var(--haus-orderConfirmation__root__display, grid);
  gap: var(--haus-orderConfirmation__root__gap, 24px);
}

.summarySection {
  display: var(--haus-orderConfirmation__summarySection__display, block);
}

.error {
  background-color: var(--haus-orderConfirmation__error__background-color, #fef2f2);
  border: var(--haus-orderConfirmation__error__border, 1px solid #fecaca);
  border-radius: var(--haus-orderConfirmation__error__border-radius, 6px);
  color: var(--haus-orderConfirmation__error__color, #991b1b);
  padding: var(--haus-orderConfirmation__error__padding, 12px);
}
